export default Object.freeze([{
  id: 'RESERVE',
  name: '保留',
  flags: ['RESERVE'],
  themeType: 'success'
}, {
  id: 'DELETE',
  name: '剔除',
  flags: ['DELETE'],
  themeType: 'danger'
}])



// WEBPACK FOOTER //
// ./src/views/02Data-Audit/01Manual/manualOperatorTypes.js